class ProductMediaZoom {
  constructor() {
    // this.imageContainers = document.querySelectorAll(".product-media-container");
    // this.productImages = document.querySelectorAll(".image-magnify-lightbox");
    this.productImages = document.querySelectorAll(".product__media img");

    this.mediaToggles = document.querySelectorAll(".product__media-toggle");
    this.modalDialog = document.querySelector(".product-media-modal__content");
    this.modalCloseButton = document.querySelector(".modal-close-btn");

    this.imageContainers = Array.from(document.querySelectorAll(".product-media-container"))
  .filter(container => container.dataset.mediaType === "image");
    
    this.init();
  }

  init() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    let imageIndex = 0;

    this.mediaToggles.forEach((mediaToggle) => {
      const mediaType = mediaToggle.dataset.mediaType || "image"; // Correct attribute usage
       console.log(mediaType);
        if (mediaType === "video") {
          mediaToggle.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation(); // Prevent any parent event from firing
            this.handleVideoClick(mediaToggle);
          });
        }

      else {
        const currentImageIndex = imageIndex;

        mediaToggle.addEventListener("mousemove", (e) => this.handleMouseMove(e, currentImageIndex));
        mediaToggle.addEventListener("mouseleave", () => this.handleMouseLeave(currentImageIndex));
        mediaToggle.addEventListener("click", (e) => {
          e.preventDefault();
          this.handleClick(currentImageIndex, mediaType);
        });

        imageIndex++; // Only increment for images
      }
    });

    if (this.modalCloseButton) {
      this.modalCloseButton.addEventListener("click", () => this.closeModal());
    }

    // Optional: ESC key to close modal
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") this.closeModal();
    });
  }

handleMouseMove(e, index) {
  const imageContainer = this.imageContainers[index];
  const productImage = this.productImages[index];

  if (!imageContainer || !productImage) return;

  const containerRect = imageContainer.getBoundingClientRect();
  const offsetX = (e.clientX - containerRect.left) / containerRect.width;
  const offsetY = (e.clientY - containerRect.top) / containerRect.height;

  productImage.style.transformOrigin = `${offsetX * 100}% ${offsetY * 100}%`;
  productImage.style.transform = `scale(1.5)`;
}


  handleMouseLeave(index) {
    const productImage = this.productImages[index];
    if (productImage) {
      productImage.style.transform = "scale(1)";
      productImage.style.transformOrigin = "center center";
    }
  }

  handleClick(imageIndex, mediaType) {
    console.log('handleClick',mediaType);
    if (mediaType !== "image") return;

    const productImage = this.productImages[imageIndex];
    if (!productImage) return;

    const modalImage = document.createElement("img");
    modalImage.src = productImage.src;
    modalImage.alt = productImage.alt;
    modalImage.classList.add("modal-image", "active");

    this.modalDialog.innerHTML = "";
    this.modalDialog.appendChild(modalImage);
    this.modalDialog.classList.add("active");
  }

  handleVideoClick(mediaToggle) {
    console.log(mediaToggle);
    const parentElement = mediaToggle.closest("modal-opener");
    const nextElement = parentElement ? parentElement.nextElementSibling : null;

    if (parentElement) parentElement.style.display = "none";
    if (nextElement) nextElement.style.display = "block";

    const videoElement = nextElement ? nextElement.querySelector("video") : null;
    if (videoElement) {
      videoElement.play();
    }
  }

    closeModal() {
      this.modalDialog.classList.remove("active");
      this.modalDialog.innerHTML = ""; // Clear the image from the modal
    }

}

// Instantiate the class
const productMediaZoom = new ProductMediaZoom();
